import { useState } from "react";
import { cadastrarLead } from "../../../services/cadastrarLeadService";
import { buscarLeadsByCelService } from "../../../services/buscarLeadsByCelService";
import { numberPadrao } from "../../../uteis/formatPhoneNumber";

export type LeadCriado = {
  id: number;
  pessoaId: number;
  nome?: string | null;
  celular?: string | null;
  status?: string;
  tipo?: string;
};

export const useCadastrarLead = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState<boolean | null>(null);
  const [success, setSuccess] = useState<boolean | null>(null);
  const [warning, setWarning] = useState<boolean | null>(null);

  const resetError = () => setError(null);
  const resetWarning = () => setWarning(null);

  // ✅ agora retorna o criado
  const cadastrar = async (leadData: any): Promise<LeadCriado | null> => {
    setIsLoading(true);
    setError(null);
    setWarning(null);
    setIsSuccess(false);

    leadData.celular = numberPadrao(leadData.celular);

    try {
      const lead = {
        ...leadData,
        nome:
          leadData.nome === undefined
            ? `MC${leadData.celular.slice(-8)}`
            : leadData.nome,
        active: 1,
        status: "DIVULGAR",
        tipo: "LEAD",
      };

      const verificacao = await buscarLeadsByCelService(leadData.celular);

      if (verificacao) {
        setWarning(true);
        return null;
      }

      const criado = await cadastrarLead(lead);

      if (criado) {
        setSuccess(true);
        return criado as LeadCriado; // (melhor: tipar o service também)
      }

      setError(true);
      return null;
    } catch (err) {
      console.error(err);
      setError(true);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    cadastrar,
    isLoading,
    isSuccess,
    error,
    success,
    warning,
    resetError,
    resetWarning,
  };
};
